if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }

      this.initHavaleCard();
    }

    initHavaleCard() {
      const card = this.querySelector('.m-installments-tab__havale');
      if (!card) return;

      const discount = parseInt(card.dataset.havaleDiscount, 10) || 10;
      const multiplier = (100 - discount) / 100;

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
        const variant = e.data && e.data.variant;
        if (!variant) return;

        const price = variant.price;
        const havalePrice = Math.round(price * multiplier);
        const savings = price - havalePrice;

        const priceEl = card.querySelector('[data-havale-price]');
        const originalEl = card.querySelector('[data-product-price]');
        const savingsEl = card.querySelector('[data-havale-savings]');

        if (priceEl) priceEl.textContent = formatMoney(havalePrice, MinimogSettings.money_format);
        if (originalEl) originalEl.textContent = formatMoney(price, MinimogSettings.money_format);
        if (savingsEl) savingsEl.textContent = formatMoney(savings, MinimogSettings.money_format) + ' tasarruf';
      });
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
